import { AbstractControl, ValidatorFn } from '@angular/forms';

export class PasswordValidator {

  static validate(control: AbstractControl) {
    const regex = /^[0-9]{5}/;

    const value = control.value;
    if (value && value.lenght >= 5) {
      if (!regex.test(value)) {
        return { invalidPasswordNumber: true };
      }
    }
    return null;
  }

}
